import * as SwitchPrimitive from "@radix-ui/react-switch";
import { rankWith, type ControlProps, type RankedTester } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { CATALOG_RENDERER_NAMES } from "../../shared/constants/catalogReviewConstants";
import { CaseFieldRow } from "../../shared/renderers/CaseReviewRenderers";
import { useImeSeriousness } from "../hooks/useImeSeriousness";
import { ImeSeriousnessDialog } from "../components/ImeSeriousnessDialog";
import { IME_SERIOUSNESS_TEXT } from "../constants/imeSeriousnessLabels";

/**
 * "Derive seriousness from the EMA IME list" of one event: a switch, off by default, that a reviewer can turn only in
 * edit mode. Read mode shows the saved state. Turning it on asks for a confirmation first; the note under it says what
 * a later change of the Preferred Term did.
 */
function ImeSeriousnessControl(props: ControlProps) {
  const ime = useImeSeriousness(props);
  const field = ime.status ? { ...ime.field, valueNote: ime.status.message } : ime.field;
  return <CaseFieldRow props={props} field={field}>{(editable) => <>
    <SwitchPrimitive.Root id={ime.field.inputId} className="cr-switch" checked={ime.on}
      disabled={!editable || !ime.available} aria-label={ime.field.label} onCheckedChange={ime.turn}>
      <SwitchPrimitive.Thumb className="cr-switch-thumb" />
    </SwitchPrimitive.Root>
    {ime.status?.retry && <button type="button" className="cr-revert" onClick={ime.status.retry}>{IME_SERIOUSNESS_TEXT.retry}</button>}
    <ImeSeriousnessDialog confirmation={ime.confirmation} onAccept={ime.accept} onCancel={ime.cancel} />
  </>}</CaseFieldRow>;
}

/** Ranked above the ordinary control, so only the field that the catalog marks for it is affected. */
export const imeSeriousnessTester: RankedTester = rankWith(11, (uischema) =>
  (uischema as { options?: { renderer?: string } }).options?.renderer === CATALOG_RENDERER_NAMES.IME_SERIOUSNESS);

export const imeSeriousnessRenderer = withJsonFormsControlProps(ImeSeriousnessControl);
